module.exports = __webpack_public_path__ + "static/media/14.2cb6b4dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/thumbs/14.jpg
// module id = 155
// module chunks = 0